<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="container p-3">
    <p>
      Quality Assurance - Reporting Phase Page.
    </p>
  </div>
  <div>
    <button class="btn btn-primary" @click="goToQualityAssuranceFileUploads">Next</button>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
</script>
<script>
export default {
  methods: {
    goToQualityAssuranceFileUploads() {
      this.$router.push('/qualityAssurance/QualityAssuranceFileUploads');
    }
  }
};
</script>
<style scoped>
</style>

